import React from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import DeleteButton from 'photo-module/photo/ui/photo-viewer/actions-bar/DeleteButton'
import PreviousButton from 'photo-module/photo/ui/photo-viewer/actions-bar/PreviousButton'
import NextButton from 'photo-module/photo/ui/photo-viewer/actions-bar/NextButton'
import FullscreenOverlayButton from 'photo-module/photo/ui/photo-viewer/actions-bar/FullscreenOverlayButton'
import useSelectedPhoto from 'photo-module/photo/core/useSelectedPhoto'
import usePhotoViewerNavigation from 'photo-module/photo/core/usePhotoViewerNavigation'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '112px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      gap: 0,
      width: '100%',
      position: 'relative',
      height: '70px',
    },
  },
  containerFirstPhoto: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  containerLastPhoto: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  prevButton: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: '10px !important',
      margin: '0 0 0 20px !important',
    },
    '& .MuiFab-root': {
      borderRadius: '6px !important',
    },
  },
  nextButton: {
    [theme.breakpoints.down('sm')]: {
      marginRight: '15px !important',
      margin: '0 20px 0 0 !important',
    },
    '& .MuiFab-root': {
      borderRadius: '6px !important',
    },
  },
  navigationActions: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '18px',
    paddingHorizontal: '24px',
    borderRadius: '6px',
    zIndex: 1000,
    width: '160px',
    maxWidth: '160px',
    height: '60px',
    [theme.breakpoints.down('sm')]: {
      height: '50px',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      top: '10px',
      paddingHorizontal: '24px',
      gap: '6px',
      width: '120px',
      maxWidth: '1Z0px',
    },
    '& svg': {
      '& path': {
        fill: theme.palette.secondary.contrastText,
      },
      height: '25px',
      width: '25px',
      [theme.breakpoints.down('sm')]: {
        height: '25px',
        width: '25px',
      },
    },
  },
}))

const NAVIGATION_BUTTON_STYLES = {
  borderRadius: '2px !important',
  padding: '12px !important',
  width: '48px !important',
  height: '48px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  '&:focus': {
    outline: '2px solid rgba(255, 255, 255, 0.5)',
    outlineOffset: '2px',
  },
}
const NavigationActions = () => {
  const classes = useStyles()
  const photo = useSelectedPhoto()
  const { previousPhoto, nextPhoto } = usePhotoViewerNavigation(photo?.id)
  const isFirstPhoto = !previousPhoto && nextPhoto
  const isLastPhoto = !nextPhoto && previousPhoto

  return (
    <Box
      className={`${classes.container} ${isFirstPhoto ? classes.containerFirstPhoto : ''} ${isLastPhoto ? classes.containerLastPhoto : ''}`}
      data-testid="navigation-actions-container"
    >
      <PreviousButton
        className={classes.prevButton}
        style={NAVIGATION_BUTTON_STYLES}
      />
      <Box className={classes.navigationActions} data-testid="navigation-actions-center">
        <DeleteButton />
        <FullscreenOverlayButton />
      </Box>
      <NextButton
        className={classes.nextButton}
        style={NAVIGATION_BUTTON_STYLES}
      />
    </Box>
  )
}

export default NavigationActions
